import classNames from "classnames";
import { GLOBAL_CONSTANTS } from "../../global/constants";
import { defer } from "../../utils/script";
import { replaceVariable } from "../../utils/string";
import { DComponent } from "../DComponent";

export default class ModalDialog extends DComponent {
  constructor({
    parent,
    id,
    type = GLOBAL_CONSTANTS.DIALOG_TYPE.NOTICE,
    isShow = false,
    isShowStatic = false,
    icon = "",
    title = "",
    titleI18n = "",
    description = "",
    descriptionI18n = "",
    btnSubmit = "",
    btnSubmitI18n = "",
    btnCancel = "",
    btnCancelI18n = "",
    isLoading = false,
    onSubmit,
    onCancel,
    onHide,
    params = {},
    className,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("ModalDialog", className, {
        "loading": isLoading
      })
    });
    this.type = type;
    this.isShow = isShow;
    this.isShowStatic = isShowStatic;
    this.icon = icon;
    this.title = title;
    this.titleI18n = titleI18n;
    this.description = description;
    this.descriptionI18n = descriptionI18n;
    this.btnSubmit = btnSubmit;
    this.btnSubmitI18n = btnSubmitI18n;
    this.isLoading = isLoading;
    this.btnCancel = btnCancel;
    this.btnCancelI18n = btnCancelI18n;
    this.onSubmit = onSubmit;
    this.onCancel = onCancel;
    this.onHide = onHide;
    this.params = params;
    this.className = className;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "ModalDialog");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    this.fillModalDialog();
    if (this.isShow) {
      this.show();
    }
    if (this.isShowStatic) {
      this.showStatic();
    }
  }

  show() {
    $("html, body").css("overflow", "hidden");
    this.element.removeClass("show-static");
    $(this.element).modal("show");
  }

  showStatic() {
    $("html, body").css("overflow", "hidden");
    this.element.addClass("show-static");
    $(this.element).modal({ backdrop: 'static' });
  }

  hide() {
    $(this.element).modal("hide");
  }

  isShowDialog() {
    return $(this.element).hasClass("show");
  }

  setButtonLoading(loading) {
    this.isLoading = loading;
    if (loading) {
      $(this.element).addClass("loading");
      $(".btn-submit", this.element).addClass("loading");
    } else {
      $(this.element).removeClass("loading");
      $(".btn-submit", this.element).removeClass("loading");
    }
  }

  fillModalDialog() {
    if (this.type === GLOBAL_CONSTANTS.DIALOG_TYPE.CONFIRM) {
      $(".modal-content", this.element).html(
        replaceVariable(require("html-loader!./confirm.html"), {
          icon: this.icon,
          title: this.title,
          titleI18n: this.titleI18n,
          description: this.description,
          descriptionI18n: this.descriptionI18n,
          btnSubmit: this.btnSubmit,
          btnSubmitI18n: this.btnSubmitI18n,
          btnCancel: this.btnCancel,
          btnCancelI18n: this.btnCancelI18n,
        })
      )
      $(".btn-cancel", this.element).on("click", () => {
        if (!this.isLoading) {
          if (typeof this.onCancel == "function") {
            this.onCancel(this.params);
          } else {
            $(this.element).modal("hide");
          }
        }
      })
    } else {
      $(".modal-content", this.element).html(
        replaceVariable(require("html-loader!./notice.html"), {
          icon: this.icon,
          title: this.title,
          titleI18n: this.titleI18n,
          description: this.description,
          descriptionI18n: this.descriptionI18n,
          classAction: !this.btnSubmit && !this.btnSubmitI18n ? "hide" : "",
          btnSubmit: this.btnSubmit,
          btnSubmitI18n: this.btnSubmitI18n,
        })
      )
    }

    $(".btn-submit", this.element).off("click")
    $(".btn-submit", this.element).on("click", () => {
      if (!this.isLoading) {
        if (typeof this.onSubmit == "function") {
          this.onSubmit(this.params);
        } else {
          $(this.element).modal("hide");
        }
      }
    })
    $(this.element).off('hide.bs.modal');
    $(this.element).on('hide.bs.modal', () => {
      $("html, body").css("overflow", "auto");
      if (typeof this.onHide == "function") {
        this.onHide();
      }
    })
  }

  /** @param {ModalDialog} newParams */
  updateDialog(newParams = {}) {
    defer(() => this.element, () => {
      Object.keys(DEFAULT_PROP).forEach(key => {
        this[key] = newParams[key] !== undefined ? newParams[key] : DEFAULT_PROP[key];
      });
      this.fillModalDialog();
      this.update();
    });
  }

  /** @param {ModalDialog} _params */
  updateAttributes(_params = {}) {
    defer(() => this.element, () => {
      Object.keys(_params).forEach(key => {
        this[key] = _params[key];
      });
    });
  }
}

const DEFAULT_PROP = {
  parent: "",
  type: GLOBAL_CONSTANTS.DIALOG_TYPE.NOTICE,
  isShow: false,
  isShowStatic: false,
  icon: "",
  title: "",
  titleI18n: "",
  description: "",
  descriptionI18n: "",
  btnSubmit: "",
  btnSubmitI18n: "",
  btnCancel: "",
  btnCancelI18n: "",
  isLoading: false,
  onSubmit: undefined,
  onCancel: undefined,
  onHide: undefined,
  params: {},
  className: "",
}